export const MAX_ZOOM = 12
export const MIN_ZOOM = 3
export const DEFAULT_ZOOM = 5

export const defaultProps = {
  clusterRadius: 100,
  hoverDistance: 100,
  options: {
    minZoom: MIN_ZOOM,
    maxZoom: MAX_ZOOM,
    zoom: DEFAULT_ZOOM,
  },
}
